import { getQuery, insertQuery, updateQuery } from "api/UdasWrapper";
import { addErrorLog } from "../Logger/logger";
import { uncompressRows } from "helpers/common";
import { createFlow } from "./FlowDesignerApis";

export const insertFlow = async (tenantId, input) => {
  return createFlow(tenantId, input, false, false);
};

export const getFlows = async (tenant_id) => {
  let data = JSON.stringify({
    query: `query Flows($tenantId: String!) {
      flows(tenant_id: $tenantId) {
        id
        tenant_id
        name
        description
        steps
        created_by
        created_by_id
        created_date_time
        platform_name
        platform_type
        notes
        group_id
        group_name
        shared_status
        shared_link
        trashed
        updated_date_time
        price
        publish_status
        integrations
        connectors
        current_version
      }
    }`,
    variables: { tenantId: tenant_id }
  });
  try {
    const result = (await getQuery(data))?.flows;

    return uncompressRows(result);
  } catch (error) {
    addErrorLog("query Flows", error, tenant_id);
  }
};

export const getCheckFlowScheduleUsage = async (tenant_id, flow_id) => {
  const data = JSON.stringify({
    query: `query CheckFlowScheduleUsage($tenantId: String!, $flowId: String!) {
      checkFlowScheduleUsage(tenant_id: $tenantId, flow_id: $flowId) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      flowId: flow_id
    }
  });
  try {
    return (await getQuery(data))?.checkFlowScheduleUsage;
  } catch (error) {
    addErrorLog("query CheckFlowScheduleUsage", error, tenant_id);
    return null;
  }
};

export const fetchWorkflowActivities = async (tenant_id, user_id, start_date, end_date) => {
  let data = JSON.stringify({
    query: `query GetWorkFlowActivities($tenant_id: String!, $user_id: String!, $start_date: DateTime, $end_date: DateTime) {
      getWorkFlowActivities(tenant_id: $tenant_id, user_id: $user_id, start_date: $start_date, end_date: $end_date) {
        datasets
        months
      }
    }`,
    variables: { tenant_id, user_id, start_date, end_date }
  });
  try {
    return (await getQuery(data))?.getWorkFlowActivities;
  } catch (error) {
    addErrorLog("query GetWorkFlowActivities", error, tenant_id);
  }
};

export const fetchAnalyticsActivities = async (tenant_id) => {
  let data = JSON.stringify({
    query: `query Analytics($tenantId: String!) {
      analytics(tenant_id: $tenantId) {
        flows
        connectors
        execution
      }
    }`,
    variables: {
      tenantId: tenant_id
    }
  });
  try {
    return (await getQuery(data))?.analytics;
  } catch (error) {
    addErrorLog("query Analytics", error, tenant_id);
  }
};

export const shareFlow = async (tenant_id, input) => {
  let data = JSON.stringify({
    query: `mutation CreateUserFlowsMultiple($tenantId: String!, $input: UserFlowsMultiInput) {
      createUserFlowsMultiple(tenant_id: $tenantId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId: tenant_id,
      input: input
    }
  });
  try {
    return (await insertQuery(data))?.createUserFlowsMultiple;
  } catch (error) {
    addErrorLog("mutation CreateUserFlowsMultiple", error, tenant_id);
  }
};

export const updateFlowStatus = async (tenant_id, updateFlowsStatusId, status) => {
  let data = JSON.stringify({
    query: `mutation UpdateFlowsStatus($tenantId: String!, $updateFlowsStatusId: String!, $status: String!) {
                updateFlowsStatus(tenant_id: $tenantId, id: $updateFlowsStatusId, status: $status) {
                  isSuccessful
                  message
                  resultObject
                }
              }`,
    variables: {
      tenantId: tenant_id,
      updateFlowsStatusId,
      status
    }
  });
  try {
    return (await updateQuery(data))?.updateFlowsStatus;
  } catch (error) {
    addErrorLog("mutation UpdateFlowsStatus", error, tenant_id);
  }
};
